import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  canonical,
  ogImage,
  ogType = 'website',
  twitterCard = 'summary_large_image',
  noIndex = false,
  structuredData = null,
  keywords = '',
  author = 'Twisted Cloud Solutions'
}) => {
  // Default values
  const defaultTitle = 'Twisted Cloud Solutions - Professional Cloud Services & AI Integration';
  const defaultDescription = 'Transform your business with cutting-edge cloud solutions, AI integration, and mobile applications. Expert cloud consulting and development services.';
  const defaultOgImage = '/images/og-default.jpg';
  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://twistedcloudsolutions.com';
  
  // Construct full title
  const fullTitle = title ? `${title} | Twisted Cloud Solutions` : defaultTitle;
  
  // Construct canonical URL
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
  
  // Construct full image URL
  const fullOgImage = ogImage ? 
    (ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`) :
    `${siteUrl}${defaultOgImage}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Twisted Cloud Solutions" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={fullOgImage} />
      <meta name="twitter:creator" content="@twistedcloud" />
      <meta name="twitter:site" content="@twistedcloud" />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content={noIndex ? 'noindex,nofollow' : 'index,follow'} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      
      {/* Structured Data */}
      {structuredData && (
        Array.isArray(structuredData) ? 
          structuredData.map((schema, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          )) :
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
      )}
    </Helmet>
  );
};

export default SEO;